module.exports = __webpack_public_path__ + "static/media/purepapercolor-skin-grey-010-1200x2490.988e9096.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/purepapercolor-skin-grey-010-1200x2490.jpg
// module id = 1095
// module chunks = 37